export default "__VITE_ASSET__ef2b9b0a__"